import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { MyContext } from "../../Context/MyProvider";

/**
 * Booking-linked Pay-via-App offer picker.
 * onChange(null | { partner, offer_id, discount_amount, payable_amount, original_bill })
 */
export default function PayAppOfferSelector({
  partnerType,
  partnerId,
  billAmount,
  customerId,
  onChange
}) {
  const { ApiBaseUrl } = useContext(MyContext);
  const [partner, setPartner] = useState(null);
  const [offers, setOffers] = useState([]);
  const [offerId, setOfferId] = useState("");

  useEffect(() => {
    if (!partnerType || !partnerId) return;
    axios
      .get(`${ApiBaseUrl}/pv/customer/partner_resolve`, {
        params: { partner_type: partnerType, partner_id: partnerId }
      })
      .then((r) => {
        if (r.data.Result && r.data.partner) setPartner(r.data.partner);
        else {
          setPartner(null);
          onChange?.(null);
        }
      })
      .catch(() => setPartner(null));
  }, [partnerType, partnerId, ApiBaseUrl]);

  useEffect(() => {
    if (!partner || !billAmount || Number(billAmount) <= 0) {
      setOffers([]);
      return;
    }
    axios
      .post(`${ApiBaseUrl}/pv/customer/offers/preview`, {
        partner_profile_id: partner.id,
        customer_id: customerId || 0,
        bill_amount: billAmount
      })
      .then((r) => setOffers((r.data.offers || []).filter((o) => !o.ineligible)));
  }, [partner, billAmount, customerId, ApiBaseUrl]);

  if (!partner || !offers.length) return null;

  const pick = (id) => {
    setOfferId(id);
    if (!id) {
      onChange?.(null);
      return;
    }
    const o = offers.find((x) => String(x.offer.id) === String(id));
    if (!o) return onChange?.(null);
    onChange?.({
      partner,
      offer_id: o.offer.id,
      discount_amount: o.discount_amount,
      payable_amount: o.payable_amount,
      original_bill: Number(billAmount)
    });
  };

  return (
    <div className="border rounded-xl p-3 mb-4 bg-orange-50">
      <p className="font-semibold text-rm-ink mb-2">Pay via App offers</p>
      <p className="text-xs text-gray-600 mb-2">Partner-funded discount at {partner.display_name}</p>
      <label className="flex gap-2 items-center text-sm mb-2">
        <input type="radio" name={`pv-offer-${partner.id}`} checked={!offerId} onChange={() => pick("")} />
        No Pay-via-App offer
      </label>
      {offers.map((o) => (
        <label key={o.offer.id} className="flex gap-2 items-start text-sm mb-2 cursor-pointer">
          <input
            type="radio"
            name={`pv-offer-${partner.id}`}
            checked={String(offerId) === String(o.offer.id)}
            onChange={() => pick(o.offer.id)}
          />
          <span>
            <b>{o.offer.name}</b>
            <span className="text-green-700"> — Save ₹{o.discount_amount}, pay ₹{o.payable_amount}</span>
          </span>
        </label>
      ))}
    </div>
  );
}
